/**
 * PaymentMethodService
 * Service for PaymentMethod entity operations
 * Route: api/payment-method
 * Controller: PaymentMethodController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * PaymentMethodService
 * Handles payment method CRUD operations
 * Maps to /api/payment-method endpoint
 */
export class PaymentMethodService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PaymentMethodService.DEFAULT_SERVICE_PATH,
            basePath: PaymentMethodService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate payment method cache
     * POST /api/payment-method/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate payment method cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
PaymentMethodService.DEFAULT_SERVICE_PATH = 'payments';
PaymentMethodService.BASE_PATH = 'api/payment-method';
//# sourceMappingURL=PaymentMethodService.js.map